
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns362ad878645cfd94d0ee05ae98b5912een from './en.yaml'
            i18n.addResourceBundle('en', '362ad878645cfd94d0ee05ae98b5912e', flattenObject(ns362ad878645cfd94d0ee05ae98b5912een), true, true);
        
        export default '362ad878645cfd94d0ee05ae98b5912e';
    